import removeEmptyFields from '../utils/removeEmptyFields';

export default function getBrowserInfo() {
  const browserInfo = {
    plugins: [],
    deviceType: '',
    screenWidth: window.outerWidth.toString(),
    screenHeight: window.outerHeight.toString(),
    userAgent: navigator.userAgent,
  };

  // regex searches for mobile platforms
  const mobileDevice = /android|webos|iphone|ipad|ipod|blackberry|windows phone|iemobile|opera mini|mobile|crios/i;
  // check user agent for mobile devices
  if (mobileDevice.test(navigator.userAgent)) {
    // user is on mobile
    browserInfo.deviceType = 'M';
  } else {
    // user is on a desktop
    browserInfo.deviceType = 'D';
  }

  if (navigator.plugins) {
    for (let i = 0; i < navigator.plugins.length; i += 1) {
      browserInfo.plugins.push(navigator.plugins[i].name);
    }
  }
  return removeEmptyFields(browserInfo);
}
